import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
  imprimante1,
  imprimante2,
  imprimante4,
  imprimante5,
  imprimante6,
  imprimante7,
  imprimante8,
  imprimante9,
  encre1,
  encre2,
  encre3,
  encre4,
  ruban1,
  ruban2,
  ruban3,
  ruban4,
  bac1,
  bac2,
  bac3,
  bac4,
  pdf1,
  IMPRIMANTE_PANTUM_CP2200DW,
  IMPRIMANTE_PANTUM_BM5100FDW,
  IMPRIMANTE_PANTUM_M6609N,
  IMPRIMANTE_PANTUM_P3300DN,
  IMPRIMANTE_PANTUM_P3300DW,
  IMPRIMANTE_PANTUM_P2509W,
  IMPRIMANTE_PANTUM_BP5100DN,
  IMPRIMANTE_PANTUM_M6559N,
  IMPRIMANTE_PANTUM_P2509,
  hp1,
  hp2,
  hp3,
  ricoh1,
  ricoh2,
  ricoh3,
  ricoh4,
  ricoh5,
  espson1,
  espson2,
} from "../assets/images/index";

import "./style.css";

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Shop",
    link: "/shop",
  },
  {
    _id: 1003,
    title: "About",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "contact",
  },
];
// =================== NavBarList End here ======================
// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: imprimante1,
    productName: "MSI Vector 16 ",
    price: "2499.00",
    color: "Black",
    badge: true,
    des: "Model Code : MSI Vector 16 HX A14VHG-456KH-Cosmos Gray CPU : Intel® Core™ i9 14900HX (24C/32T 5.8GHz)RAM : 16GB DDR5Storage : 1TB M.2 Gen4Screen : 16 QHD+ 240Hz 100% DCI-P3VGA : NVIDIA® RTX 4080, GDDR6 12GBKeyboard : Per-Key RGB by SteelSeriesOS : Window 11 Home License 64BitBattery : 4-Cell 99.9 Battery (Whr)Weight : 3.1 kg | Color : Cosmos Gray",
    cat: "imprimante",
  },
  {
    _id: "202",
    img: imprimante2,
    productName: "ASUS ROG G614JV-ES94",
    price: "1699.00",
    color: "Black",
    badge: true,
    des: "ASUS ROG G614JV-ES94 Gaming Laptop 13th Gen Intel® Core™ i9-13980HX Processor NVIDIA® GeForce RTX™ 4060 Laptop GPU ROG Nebula Display 16-inch 8GB DDR5-4800 SO-DIMM x 2 1TB PCIe® 4.0 NVMe™ M.2 SSD",
    cat: "imprimante",
  },
  {
    _id: "203",
    img: imprimante4,
    productName: "MSI Katana 15",
    price: ".00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
    cat: "imprimante",
  },
  {
    _id: "204",
    img: imprimante5,
    productName: "ASUS TUF Gaming F15",
    price: "220.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
    cat: "imprimante",
  },
  {
    _id: "205",
    img: imprimante6,
    productName: "Asus TUF Gaming F17",
    price: "1099.00",
    color: "Gray",
    badge: true,
    des: "Asus TUF Gaming F17 ASUS TUF Gaming F17 Laptop, 17.3” 144Hz Full HD IPS-Type, Intel Core i7-11800H Processor, GeForce RTX 3060, 16GB DDR4, 1TB PCIe SSD, Gigabit Wi-Fi 6, Windows 11 Home, TUF FX706HM-ES74",
    cat: "imprimante",
  },
  {
    _id: "206",
    img: imprimante7,
    productName: "ASUS TUF FA507NU",
    price: "999.00",
    color: "Black",
    badge: true,
    des: "ASUS TUF FA507NU-LP061W ASUS TUF Gaming F17 Laptop, 17.3” 144Hz Full HD IPS-Type, Intel Core i7-11800H Processor, GeForce RTX 3060, 16GB DDR4, 1TB PCIe SSD, Gigabit Wi-Fi 6, Windows 11 Home, TUF FX706HM-ES74",
    cat: "imprimante",
  },
  {
    _id: "207",
    img: imprimante8,
    productName: "GIGABYTE AORUS 17X",
    price: "3505.00",
    color: "Mixed",
    badge: true,
    des: "GIGABYTE AORUS 17X GIGABYTE AORUS 17X: 17.3 16:9 Thin Bezel QHD 2560x1440 240Hz, NVIDIA GeForce RTX 4090 Laptop GPU 16GB GDDR6, Intel Core i9-13980HX, 32GB DDR5 RAM, 2TB SSD, Win11 Pro(AORUS 17X AZF-D5US665SH)",
    cat: "imprimante",
  },
  {
    _id: "208",
    img: imprimante9,
    productName: "AORUS 15 GAMING",
    price: "1799.00",
    color: "Black",
    badge: true,
    des: "GIGABYTE AORUS 17H: 17.3 Thin Bezel FHD1920x1080 360Hz Display, NVIDIA GeForce RTX 4080 Laptop GPU 12GB GDDR6, Intel Core i7-13700H,16GB DDR5 RAM, 1TB SSD,Win11 Home AD(AORUS 17H BXF-74US554SH),Black",
    cat: "imprimante",
  },
  {
    _id: "209",
    img: encre1,
    productName: "Intel Core 14th Gen Extreme Gaming PC",
    price: "3499.00",
    color: "Black",
    badge: true,
    des: "Intel Core 14th Gen Extreme Gaming PC  windows 11 logo  Case:  iBUYPOWER HYTE Y70 - Black  Edit  Processor:  Intel® Core™ i9-14900KF CPU  Edit  Video Card:  GeForce RTX 4090 - 24GB  Edit  Memory:  32GB DDR5-5200MHz RAM  Edit  Primary Storage:  2TB WD M.2 NVMe SSD  Edit  Power Supply:  1000 Watt - High Power PCIe GEN 5  ",
    cat: "ancre",
  },
  {
    _id: "210",
    img: encre2,
    productName: "Intel Core 14th Gen Ultimate Gaming PC",
    price: "2879.00",
    color: "White",
    badge: true,
    des: "Intel Core 14th Gen Ultimate Gaming PC Window 11 Home Intel Core i7-13700KF CPU NVIDIA Geforce RTX 4070 Ti - 12GB 1TB WD M.2 NVMe SSD 32GB DDR5-5200MHz RAM",
    cat: "ancre",
  },
  {
    _id: "211",
    img: encre3,
    productName: "Intel Gaming PC Configurator 3",
    price: "2169.00",
    color: "Mixed",
    badge: true,
    des: "Windows 11 Home Intel® Core™ i7-14700KF CPU ASUS PRIME Z790-V WiFi 32GB DDR5-5200MHz RAM GeForce RTX 4070 SUPER - 12GB 2TB WD M.2 NVMe SSD",
    cat: "ancre",
  },
  {
    _id: "212",
    img: encre4,
    productName: "AMD Gaming PC Configurator 3",
    price: "1869.00",
    color: "White",
    badge: true,
    des: "Windows 11 Home  AMD Ryzen™ 7 7700X CPU  ASUS Prime B650M-A AX  32GB DDR5-5200MHz RAM  GeForce RTX 4070 SUPER - 12GB  2TB WD M.2 NVMe S",  
    cat: "ancre",
  },
  {
    _id: "213",
    img: ruban1,
    productName: "14th Intel®",
    price: "599.00",
    color: "Mixed",
    badge: true,
    des: "Intel® Core™ i9 14900K (24Cores,32Threads,6Ghz)",
    cat: "Ruban",
  },
  {
    _id: "214",
    img: ruban2,
    productName: "14th Intel®",
    price: " 619.00",
    color: "Mixed",
    badge: true,
    des: "Intel® Core™ i9 14900KF (24Cores,32Threads,6Ghz)",
    cat: "Ruban",
  },
  {
    _id: "215",
    img: ruban3,
    productName: "MSI Gaming GeForce RTX 4090 24GB  ",
    price: "1899.99",
    color: "Mixed",
    badge: true,
    des: "Graphics Coprocessor	NVIDIA GeForce RTX 4090 Brand	MSI Graphics Ram Size	24 GB GPU Clock Speed	2.61 GHz Video Output Interface	DisplayPort,",
    cat: "Ruban",
  },
  {
    _id: "216",
    img: ruban4,
    productName: "NVIDIA GeForce RTX 3070 8GB GDDR6 PCI Express 4.0",
    price: "1119.99",
    color: "Black",
    badge: true,
    des: "Graphics Coprocessor	NVIDIA GeForce RTX 3070 Brand	NVIDIA Graphics Ram Size	8.00 GPU Clock Speed	1695 MHz Video Output Interface	HDMI,DisplayPort,PCI Express",
    cat: "Ruban",
  },
  {
    _id: "217",
    img: bac1,
    productName: "M65 RGB Ultra Wireless tunable FPS",
    price: "129.99",
    color: "Black",
    badge: true,
    des: "M55 RGB PRO Black The CORSAIR M55 RGB PRO Gaming Mouse offers game-winning versatility with an ambidextrous design that fits any grip or hand, and a highly precise 12,400 DPI optical sensor. Mouse Warranty Two years Prog Buttons 8 DPI 12,400 DPI Sensor PMW3327 Sensor Type Optical Mouse Backlighting 2 Zone RGB On Board Memory Yes On-board Memory Profiles 1 Mouse button Type Omron Mouse Button Durability 50M L/R Click Connectivity Wired Grip Type Palm, Claw, Fingertip Weight Tuning No Weight 86g...",
    cat: "Bac",
  },
  {
    _id: "219",
    img: bac2,
    productName: "Elgato Facecam - True 1080p60 Full HD",
    price: "139.00",
    color: "Black",
    badge: true,
    des: "Elgato Facecam - True 1080p60 Full HD FEATURES • Studio quality f/2.4 24 mm* all-glass Elgato Prime Lens • Sony® STARVIS™ Sensor optimized for indoor use • True FHD 1080p resolution at sixty frames per second • Advanced image engine processes maximum data at high speed • Uncompressed video without artifacts • Up to 82 degree field of view for full frame or wide angle • Fixed focus range keeps you in focus • USB 3.0 interface transfers image data with lowest latency • Set brightness, exposure, and more in the app...",
    cat: "Bac",
  },
  {
    _id: "220",
    img: bac3,
    productName: "K60 RGB PRO Mechanical gaming keyboard",
    price: "89.99",
    color: "Mixed",
    badge: true,
    des: "K60 RGB PRO Mechanical gaming keyboard The CORSAIR K60 RGB PRO LOW PROFILE Mechanical Gaming Keyboard is built for both style and substance with a slim, durable brushed aluminum frame, CHERRY MX Low Profile SPEED mechanical keyswitches, and vivid per-key RGB backlighting.",
    cat: "Bac",
  },
  {
    _id: "221",
    img: bac4,
    productName: "HS70 PRO WIRELESS Gaming Headset — Carbon",
    price: "99.99",
    color: "Black",
    badge: true,
    des: "HS70 PRO WIRELESS Gaming Headset — Carbon The CORSAIR HS70 PRO WIRELESS Gaming Headset delivers both comfort and quality with memory foam ear pads and custom-tuned 50mm neodymium audio drivers, built to last thanks to its lightweight and durable construction. Connect to your PC or PS4 with low-latency 2.4GHz wireless, and make sure you’re heard with a fully detachable, noise-cancelling unidirectional microphone. * Connection compatibility dependent upon device. 7.1 surround sound only available on PC. Headphones •...",
    cat: "Bac",
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  {
    _id: "201",
    img: IMPRIMANTE_PANTUM_CP2200DW,
    productName: "Asus ROG STRIX Z790-F GAMING WIFI DDR5",
    price: "389.00",
    color: "Mixed",
    badge: true,
    brand: "ASUS",
    des: "Intel LGA 1700 socket: Ready for 13th Gen Intel Core processors & 12th Gen Intel Core, Pentium Gold and Celeron Processors Robust Power Solution: 16 + 1 power solution rated for 90A per stage with with dual ProCool II power connectors, high-quality alloy chokes, and durable capacitors to support multi-core processors Optimized VRM Thermals: Massive heatsinks with integrated I/O cover, high-conductivity thermal pads, and connected with an L-shaped heatpipe",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "Technology ", value: "Electrophotographic monochrome laser " },
      { label: "Print speed ", value: "22 ppm (A4)/23 ppm (Letter)" },

      { label: "First print out time ", value: "Less than 7.8s       " },
      { label: "Maximum Monthly Duty Cycle", value: "15,000 pages " },
      {
        label: "Recommended monthly volume Resolution(dpi) ",
        value: "700 pages ",
      },
      { label: "Printer language Duplex Mode ", value: "Max. 1,200×1,200 " },
      { label: "Printer  ", value: "Max. 1,2   " },
      { label: "galass  ", value: "Max. 1,2   " },
    ],
  },
  {
    _id: "202",
    img: IMPRIMANTE_PANTUM_BM5100FDW,
    productName: "ASUS  ROG STRIX B760-A GAMING WIFI DDR5",
    price: "199.99",
    color: "Black and White",
    badge: true,
    brand: "ASUS",
    des: "ASUS  ROG STRIX B760-A GAMING WIFI DDR5",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "Vitesse d'impression ", value: "40ppm(A4)/42ppm(lettre) " },
      { label: "Temps de sortie de la première page ", value: "≤6.9 s" },

      {
        label: "Nombre de pages mensuel recommandé",
        value: "750 à 4,000 Pages",
      },
      { label: "Résolution d'impression", value: "Max.1,200x1,200 dpi" },
      {
        label: "Langage d'impression ",
        value: "PCL5e, PCL6, PS        ",
      },
      { label: "Vitesse du processeur", value: "1.2 GHz" },
      { label: "Mémoire", value: "512 MB" },
      {
        label: "Panneau de commande ",
        value: "LCD 2 lignes ||  Écran tactile 3,5 pouces      ",
      },
      { label: "Impression recto-verso automatique      ", value: "Oui" },
      {
        label: "Autres fonctions d'impression      ",
        value:
          "Impression brochure, impression sécurisée, impression disque USB Compatible AirPrint, Mopria, APP mobile (APP iOS/App Android)",
      },
      { label: "Vitese de copie ", value: "40ppm(A4)/42ppm(lettre)" },
      {
        label: "Temps de sortie de la première page",
        value: "Plateau : moins de 10 s ADF : moins de 11 s",
      },
    ],
  },

  {
    _id: "203",
    img: IMPRIMANTE_PANTUM_BP5100DN,
    productName: "ASUS ROG STRIX Z790-H Gaming (WiFi 6E)LGA 1700",
    price: "299.99",
    color: "Black",
    badge: true,
    brand: "ASUS",
    des: "Imprimante Monochrome Laser PANTUM BP5100DN : Fonctions Impression - :Capacité Bac à papier 250 pages - :Formats papier -: A4 - Technologie d’impression Laser Monochrome - :Vitesse d’impression Noir & Blanc Jusqu’à 40 pages par minute en A4 -: Résolution 1200 dpi -: Mémoire 512 Mo - Connectivité Ethernet, USB 2.0 -:Auto-Duplex-, Network-Ready : Impression silencieuse - faible encombrement et respectueux de l'environnement -: cartouches à haut rendement en option - processeur haute vitesse 1,2 GHz - Dimensions: 364 x 344 x 257 mm - Poids: 9.3 kg - Garantie: 1 an",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "Vitesse d'impression ", value: "40ppm(A4)/42ppm(lettre) " },
      { label: "Temps de sortie de la première page ", value: "≤6.9 s" },

      {
        label: "Nombre de pages mensuel recommandé",
        value: "750 à 4,000 Pages",
      },
      { label: "Résolution d'impression", value: "Max.1,200x1,200 dpi" },
      {
        label: "Langage d'impression ",
        value: "PCL5e, PCL6, PS        ",
      },
      { label: "Vitesse du processeur", value: "1.2 GHz" },
      { label: "Mémoire", value: "512 MB" },
      {
        label: "Panneau de commande ",
        value: "LCD 2 lignes ||  Écran tactile 3,5 pouces      ",
      },
      { label: "Impression recto-verso automatique      ", value: "Oui" },
      {
        label: "Autres fonctions d'impression      ",
        value:
          "Impression brochure, impression sécurisée, impression disque USB Compatible AirPrint, Mopria, APP mobile (APP iOS/App Android)",
      },
      { label: "Vitese de copie ", value: "40ppm(A4)/42ppm(lettre)" },
      {
        label: "Temps de sortie de la première page",
        value: "Plateau : moins de 10 s ADF : moins de 11 s",
      },
    ],
  },
  {
    _id: "2005",
    img: IMPRIMANTE_PANTUM_M6609N,
    productName: "MSI  Vector GP77 13VG-037KH",
    price: "1799.00",
    color: "Black",
    badge: true,
    brand: "MSI",
    des: "CPU : Intel® Core™ i7-13700H (14C,20Th,5.0 GHz) RAM : 16GB (8x2) DDR5-4800Mhz Storage : 1TB M.2 PCie SSD Screen : 17.3 QHD (2560x1440), 240Hz GPU : GeForce RTX™ 4070 8GB GDDR6 Keyboard : Per-Key RGB by SteelSeries OS : Window 11 Home License 64Bit Battery : 4-Cell 65 Battery (Whr) Weight : 2.8 kg | Color : Black",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "gtin	", value: "M6559N      " },
      { label: "Marque	", value: "PANTUM      " },
      { label: "fonctions	", value: "Monofonction      " },
      { label: "Technologie d impression		", value: "Laser      " },
      { label: "Impression	", value: "Noir & Blanc      " },
      { label: "Vitesse du Processeur		", value: "600MHz      " },
      {
        label: "Capacité papier		",
        value: "Capacité standard: 1 600 pages      ",
      },
      { label: "Gestion d entrée Papier Standard		", value: "150 pages      " },
      { label: "Premiére Page Imprimée		", value: "Moins de 7.8s      " },
      { label: "Cycle d utilisation Mensuel		", value: "15 000 pages      " },
      {
        label: "Résolution d impression		",
        value: "Max. 1 200 × 1 200 ppp      ",
      },
      {
        label: "Résolution d'impression Noir		",
        value: "Max. 1 200 × 1 200 ppp      ",
      },
      { label: "formats		", value: "A4      " },
      { label: "Sortie papier		", value: "100 pages      " },
      {
        label: "Vitesse de Copie Noir Blanc		",
        value: "22 ppm (A4) / 23 ppm (Lettre)      ",
      },
      { label: "Poids		", value: "4,75 kg      " },
    ],
  },

  {
    _id: "20005",
    img: IMPRIMANTE_PANTUM_M6559N,
    productName: "Katana 17 B13VGK-1082KH",
    price: "1549.00",
    color: "Black",
    badge: true,
    brand: "MSI",
    des: " CPU : Intel® Core™ i9-13900H (14C,20Th, 5.40 GHz) - RAM : DDR5 16GB 4800Mhz  - Storage : 1TB NVMe PCIe  Gen4 - Screen : 17.3 QHD (2560*1440), 240Hz DCI-P3 100% - VGA : NVIDIA® RTX 4070 8GB GDDR6 - Keyboard : 4 Zone RGB Keyboard  - OS : Window 11 Home License 64Bit - Battery : 3-Cell 53.5 Battery (Whr) - Weight : 2.6 kg | Color : Black",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "gtin	", value: "M6559N      " },
      { label: "Marque	", value: "PANTUM      " },
      { label: "fonctions	", value: "Monofonction      " },
      { label: "Technologie d impression		", value: "Laser      " },
      { label: "Impression	", value: "Noir & Blanc      " },
      { label: "Vitesse du Processeur		", value: "600MHz      " },
      {
        label: "Capacité papier		",
        value: "Capacité standard: 1 600 pages      ",
      },
      { label: "Gestion d entrée Papier Standard		", value: "150 pages      " },
      { label: "Premiére Page Imprimée		", value: "Moins de 7.8s      " },
      { label: "Cycle d utilisation Mensuel		", value: "15 000 pages      " },
      {
        label: "Résolution d impression		",
        value: "Max. 1 200 × 1 200 ppp      ",
      },
      {
        label: "Résolution d'impression Noir		",
        value: "Max. 1 200 × 1 200 ppp      ",
      },
      { label: "formats		", value: "A4      " },
      { label: "Sortie papier		", value: "100 pages      " },
      {
        label: "Vitesse de Copie Noir Blanc		",
        value: "22 ppm (A4) / 23 ppm (Lettre)      ",
      },
      { label: "Poids		", value: "4,75 kg      " },
    ],
  },

  {
    _id: "206",
    img: IMPRIMANTE_PANTUM_P3300DN,
    productName: "MSI Cyborg 15 A12VF-234KH ",
    price: "1149.00",
    color: "Black",
    badge: true,
    brand: "MSI",
    des: "CPU : Intel® Core™ i7-12650H (10C,16Th,4.70 GHz) RAM : 16GB DDR5 4800Mhz Storage :  1TB M.2 Screen : 15.6 FHD (1920x1080), 144Hz VGA : NVIDIA® RTX™ 4060 8GB GDDR6 Keyboard : Single Backlit Keyboard (Blue) OS : Window 11 Home License 64Bit Battery : 3-Cell 53.5 Battery (Whr) Weight : 1.98 kg | Color : Black",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "gtin	", value: "P3300DN      " },
      { label: "fonctions	", value: "Monofonction      " },
      { label: "Mémoire	", value: "256MO      " },
      { label: "Technologie d impression		", value: "laser      " },
      { label: "Impression		", value: "Noir & Blanc      " },
      { label: "Connectivite		", value: "Réseau      " },
      { label: "Vitesse du Processeur		", value: "350 MHz      " },
      { label: "Type ecran		", value: "LCD 2 lignes      " },
      {
        label: "Consommation d énergie		",
        value:
          "Impression : 525 W en moyenne Veille : 50 W en veille : moins de 2 W      ",
      },
      {
        label: "Gestion d entrée Papier Standard		",
        value: "Papier Bac d'alimentation: 250pages      ",
      },
      { label: "Premiére Page Imprimée		", value: "Moins de 8,2 secondes      " },
      {
        label: "Vitesse d impression Noir		",
        value: "33 ppm (A4) / 35 ppm (Lettre)      ",
      },
      { label: "Cycle d utilisation Mensuel		", value: "60000pages      " },
      {
        label: "Résolution d impression		",
        value: "1 200 x 1 200 dpi (maximum)      ",
      },
      { label: "formats	", value: "A4      " },
      {
        label: "Connecteurs		",
        value: "USB2.0 haut débit / Ethernet：IEEE 802.3 10/100Base-Tx      ",
      },
      { label: "Fonctionnalités		", value: "Impression      " },
      {
        label: "Volume de Pages Mensuel Recommandé		",
        value: "750 à 3 500 pages      ",
      },
      { label: "Dimensions		", value: "354 x 334 x 232mm      " },
      { label: "Garantie	", value: "1ANS      " },
    ],
  },

  {
    _id: "207",
    img: IMPRIMANTE_PANTUM_P3300DW,
    productName: "Msi GF63 Thin 12UCX (Intel 12th Gen)",
    price: "629.00",
    color: "Black",
    badge: true,
    brand: "MSI",
    des: " CPU : Intel® Core™ i5-12450H (8C,12Th,4.40 GHz) - RAM : 8GB DDR4 3200Mhz - Storage : 512GB M.2 PCIe  - Screen : 15.6 FHD (1920x1080) 144Hz IPS - VGA : Nvidia RTX™ 2050 4GB GDDR6  - Keyboard : Backlight Red - OS : Window 11 Home License  - Battery : 3-Cells 52whr Li-Polymer - Weight : 1.86 kg with battery | Color : Black",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "gtin		", value: "P3300DW      " },
      { label: "fonctions	", value: "Monofonction      " },
      { label: "Mémoire	", value: "256 Mo      " },
      { label: "Technologie d impression		", value: "Laser      " },
      { label: "Connectivite	", value: "WIFI      " },
      { label: "Vitesse du Processeur		", value: "350 MHz      " },
      { label: "Type ecran		", value: "LCD 2 lignes      " },
      {
        label: "Consommation d énergie		",
        value:
          "Impression : 525 W en moyenne Veille : 50 W en veille : moins de 2 W      ",
      },
      {
        label: "Gestion d entrée Papier Standard		",
        value: "Papier Bac d'alimentation: 250pages      ",
      },
      { label: "Premiére Page Imprimée		", value: "Moins de 8,2 secondes      " },
      {
        label: "Vitesse d impression Noir		",
        value: "33 ppm (A4) / 35 ppm (Lettre)      ",
      },
      { label: "Cycle d utilisation Mensuel		", value: "60000pages      " },
      { label: "Résolution d impression		", value: "Max.1200x1200 dpi      " },
      {
        label: "Volume de Pages Mensuel Recommandé		",
        value: "750 à 3 500 pages      ",
      },
      {
        label: "Interface Réseau	",
        value:
          "Ethernet USB 2.0 haut débit : Wi-Fi IEEE 802.3 10/100Base-Tx : IEEE 802.11b/g/n      ",
      },
      {
        label: "Contenu de L'emballage		",
        value:
          "Imprimante - Cordon d’alimentation - Câble d’interface USB - Plateau de sortie - CD-ROM - Guide de configuration rapide      ",
      },
      { label: "Garantie	", value: "1 ANS      " },
    ],
  },

  {
    _id: "208",
    img: IMPRIMANTE_PANTUM_P2509W,
    productName: "Asus ROG Strix RTX™ 4080 16GB White",
    price: "1,549.00",
    color: "White",
    badge: true,
    brand: "NVIDIA",
    des: "NVIDIA Ada Lovelace Streaming Multiprocessors: Up to 2x performance and power efficiency 4th Generation Tensor Cores: Up to 4x performance with DLSS 3 vs. brute-force rendering  3rd Generation RT Cores: Up to 2X ray tracing performance OC mode: 2655 MHz (OC mode)/ 2625 MHz (Default mode)  Axial-tech fans scaled up for 23% more airflow New patented vapor chamber with milled heatspreader for lower GPU temps ",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "gtin	", value: "P2509W      " },
      { label: "fonctions	", value: "Monofonction      " },
      { label: "Technologie d impression		", value: "Laser      " },
      { label: "Ecran Tactile		", value: "Non      " },
      { label: "Connectivite	", value: "WiFi      " },
      { label: "Vitesse du Processeur		", value: "600MHz      " },
      {
        label: "Capacité papier		",
        value: "Capacité standard: 1 600 pages      ",
      },
      { label: "Premiére Page Imprimée		", value: "Moins de 7.8s      " },
      { label: "Cycle d utilisation Mensuel		", value: "15 000 pages      " },
      {
        label: "Résolution d impression		",
        value: "Max. 1 200 × 1 200 ppp      ",
      },
      { label: "formats	", value: "A4      " },
      { label: "Connecteurs		", value: "USB 2.0, Wi-Fi      " },
      {
        label: "Vitesse de Copie Noir Blanc		",
        value: "22 ppm (A4) / 23 ppm (Lettre)      ",
      },
      {
        label: "Contenu de L'emballage		",
        value:
          "Imprimante - Cordon d’alimentation - Câble d’interface USB - Plateau de sortie - CD-ROM - Guide de configuration rapide      ",
      },
      { label: "Dimensions		", value: "337 x 220 x 178 mm      " },
    ],
  },
  {
    _id: "233",
    img: IMPRIMANTE_PANTUM_P2509,
    productName: "Gigabyte GeForce RTX™ 4070 AERO OC 12G",
    price: "769.00",
    color: "White",
    badge: true,
    brand: "NVIDIA",
    des: "Imprimante Laser PANTUM P2509 - Fonctions Impression - Capacité d'impression Jusqu'à :1600 pages - Formats papier: A4 - Technologie d’impression Laser Monochrome - Vitesse d’impression Noir & Blanc: Jusqu’à 22 pages par minute en A4 - Résolution: 1200 dpi - Mémoire: 128 Mo - Connectivité: USB 2.0 - Dimensions: 337 x 220 x 178 mm - Poids: 4.75 kg - Toner recheargeable - Garantie: 1 an",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [],
  },
  {
    _id: "220",
    img: bac3,
    productName: "K60 RGB PRO Mechanical gaming keyboard",
    price: "89.99",
    color: "black",
    badge: true,
    des: "K60 RGB PRO Mechanical gaming keyboard The CORSAIR K60 RGB PRO LOW PROFILE Mechanical Gaming Keyboard is built for both style and substance with a slim, durable brushed aluminum frame, CHERRY MX Low Profile SPEED mechanical keyswitches, and vivid per-key RGB backlighting.",
    cat: "Bac",
  },
  {
    _id: "221",
    img: bac4,
    productName: "HS70 PRO WIRELESS — Carbon",
    price: "99.99",
    color: "Black",
    badge: true,
    des: "HS70 PRO WIRELESS Gaming Headset — Carbon The CORSAIR HS70 PRO WIRELESS Gaming Headset delivers both comfort and quality with memory foam ear pads and custom-tuned 50mm neodymium audio drivers, built to last thanks to its lightweight and durable construction. Connect to your PC or PS4 with low-latency 2.4GHz wireless, and make sure you’re heard with a fully detachable, noise-cancelling unidirectional microphone. * Connection compatibility dependent upon device. 7.1 surround sound only available on PC. Headphones •...",
    cat: "Bac",
  },
  {
    _id: "215",
    img: ruban3,
    productName: "MSI Gaming GeForce RTX 4090 24GB",
    price: "1899.99",
    color: "Mixed",
    badge: true,
    des: "Graphics Coprocessor NVIDIA GeForce RTX 4090 Brand MSI Graphics Ram Size 24 GB GPU Clock Speed 2.61 GHz Video Output Interface DisplayPort.",
    cat: "Ruban",
  },
  {
    _id: "216",
    img: ruban4,
    productName: "NVIDIA GeForce RTX 3070 8GB GDDR6 PCI Express 4.0",
    price: "1119.00",
    color: "Black",
    badge: true,
    des: "Graphics Coprocessor NVIDIA GeForce RTX 3070 Brand NVIDIA Graphics Ram Size 8.00 GPU Clock Speed 1695 MHz Video Output Interface HDMI,DisplayPort,PCI Express",
    cat: "Ruban",
  },
  {
    _id: "209",
    img: encre1,
    productName: "Intel Core 14th Gen Extreme Gaming PC",
    price: "3499.00",
    color: "Black",
    badge: true,
    des: "Intel Core 14th Gen Extreme Gaming PC windows 11 logo Case iBUYPOWER HYTE Y70 Black Edit Processor Intel® Core™ i914900KF CPU Edit Video Card GeForce RTX 4090 24GB Edit Memory 32GB DDR55200MHz RAM Edit Primary Storage 2TB WD M.2 NVMe SSD Edit Power Supply: 1000 Watt High Power PCIe GEN 5",
    cat: "Encre",
  },
  {
    _id: "210",
    img: encre2,
    productName: "Intel Core 14th Gen Ultimate Gaming PC",
    price: "2879.00",
    color: "White",
    badge: true,
    des: "Intel Core 14th Gen Ultimate Gaming PC Window 11 Home Intel Core i7-13700KF CPU NVIDIA Geforce RTX 4070 Ti - 12GB 1TB WD M.2 NVMe SSD 32GB DDR5-5200MHz RAM ",
    cat: "Encre",
  },

  {
    _id: "211",
    img: encre3,
    productName: "Intel Gaming PC Configurator 3",
    price: "2169.00",
    color: "Black",
    badge: true,
    des: "Windows 11 Home Intel® Core™ i7-14700KF CPU ASUS PRIME Z790-V WiFi 32GB DDR5-5200MHz RAM GeForce RTX 4070 SUPER - 12GB 2TB WD M.2 NVMe SSD",
    cat: "Encre",
  },
  {
    _id: "212",
    img: encre4,
    productName: "AMD Gaming PC Configurator 3",
    price: "1869.00",
    color: "White",
    badge: true,
    des: "Windows 11 Home AMD Ryzen™ 7 7700X CPU ASUS Prime B650M-A AX 32GB DDR5-5200MHz RAM GeForce RTX 4070 SUPER - 12GB 2TB WD M.2 NVMe S",
    cat: "Encre",
  },
  {
    _id: "213",
    img: ruban1,
    productName: "14th Intel®",
    price: "599.00",
    color: "Mixed",
    badge: true,
    des: "Intel® Core™ i9 14900K (24Cores,32Threads,6Ghz)",
    cat: "Ruban",
  },
  {
    _id: "214",
    img: ruban2,
    productName: "14th Intel®",
    price: " 619.00",
    color: "Mixed",
    badge: true,
    des: "Intel® Core™ i9 14900KF (24Cores,32Threads,6Ghz)",
    cat: "Ruban",
  },

  {
    _id: "217",
    img: bac1,
    productName: "HS70 PRO WIRELESS — Carbon",
    price: "99.99",
    color: "Mixed",
    badge: true,
    des: "HS70 PRO WIRELESS Gaming Headset — Carbon The CORSAIR HS70 PRO WIRELESS Gaming Headset delivers both comfort and quality with memory foam ear pads and custom-tuned 50mm neodymium audio drivers, built to last thanks to its lightweight and durable construction. Connect to your PC or PS4 with low-latency 2.4GHz wireless, and make sure you’re heard with a fully detachable, noise-cancelling unidirectional microphone. * Connection compatibility dependent upon device. 7.1 surround sound only available on PC. Headphones •...",
    cat: "Bac",
  },
  {
    _id: "219",
    img: bac2,
    productName: "Elgato Facecam - True 1080p60 Full HD",
    price: "139.00",
    color: "Black",
    badge: true,
    des: "Elgato Facecam - True 1080p60 Full HD FEATURES • Studio quality f/2.4 24 mm* all-glass Elgato Prime Lens • Sony® STARVIS™ Sensor optimized for indoor use • True FHD 1080p resolution at sixty frames per second • Advanced image engine processes maximum data at high speed • Uncompressed video without artifacts • Up to 82 degree field of view for full frame or wide angle • Fixed focus range keeps you in focus • USB 3.0 interface transfers image data with lowest latency • Set brightness, exposure, and more in the app...",
    cat: "Bac",
  },

  // =================== imprimante hp =================

  {
    _id: "hp1",
    img: hp1,
    productName: "CORSAIR XENEON 315QHD165 32-inch Gaming Monitor",
    price: "399.99",
    color: "Black",
    badge: true,
    brand: "CORSAIR",
    des: "CORSAIR XENEON 315QHD165 32-inch Gaming Monitor Feel like you are in the game with the CORSAIR XENEON 315QHD165 IPS Gaming Monitor built with high standard of quality. Thanks to 165Hz refresh rate, NVIDIA® G-SYNC compatibility and AMD FreeSync™ Premium certification, enjoy silky-smooth, tear-free images. With dual HDMI 2.0, DisplayPort 1.4, and built-in 2-port USB hub, the XENEON 315QHD165 has all of the connectivity that you need - no matter whether you're gaming or working. Ultra-slim 32-inch QHD 2560x1440 display​ IPS...",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "DISPONIBILITÉ", value: "En stock" },
      { label: "gtin", value: "3YW70A" },
      { label: "Marque", value: "HP" },
      { label: "Destockage", value: "Non" },
      { label: "Ecran", value: "LCD" },
      {
        label: "Taille de L écran cm",
        value: "Affichage LCD 7 segments + icône 5,08 cm (2 pouces)",
      },
      { label: "Ecran Tactile", value: "Non" },
      { label: "Technologie d impression", value: "Jet d'encre" },
      { label: "fonctions", value: "Multifonction" },
      { label: "Fonctionnalités", value: "Impression, Copie, Numérisation" },
      { label: "Impression", value: "Couleur" },
      { label: "formats", value: "A4" },
      { label: "Chargement de Documents", value: "Oui" },
      { label: "Vitesse d impression Noir", value: "Jusqu'à 22 ppm" },
      { label: "Vitesse d impression Couleur", value: "Jusqu'à 16 ppm" },
      { label: "FAX", value: "Non" },
      { label: "Mémoire", value: "256 Mo" },
      {
        label: "Qualité d impression Noir",
        value: "Jusqu'à 1 200 x 1 200 ppp",
      },
      {
        label: "Qualité d impression Couleur",
        value: "Jusqu'à 4 800 x 1 200 ppp",
      },
      { label: "Résolution d impression Couleur", value: "1200x1200dpi" },
      { label: "Recto/Verso", value: "Manuel" },
      { label: "Type de Scanner", value: "Scanner à Plat" },
      { label: "Connectivite", value: "USB 2.0, WiFi" },
      { label: "Capacité papier", value: "100 feuilles" },
      { label: "Cycle d utilisation Mensuel", value: "Jusqu'à 1000 pages" },
      {
        label: "Consommation électrique",
        value:
          "0,12 Watts (Arrêt manuel), 3,12 Watts (Prêt), 0,75 Watt (Veille) 5",
      },
      { label: "Grammage", value: "75 g/m²" },
      {
        label: "Contenu de L'emballage",
        value:
          "Imprimante HP Smart Tank 516, Bouteilles d'encre: 3 x HP GT53XL (noir), 3 x HP GT52 (cyan, magenta et jaune), Notice de précaution pour l'encre; Fiche pour le ré-emballage et réglementaire RoH-EAC; Cordon d'alimentation, Guide d'installation; Notice PT",
      },
      { label: "Poids", value: "5,14 kg" },
      { label: "Dimensions", value: "447 x 373 x 158 mm" },
      { label: "Couleur", value: "Noir et Bleu" },
      { label: "Garantie", value: "1 an" },
    ],
  },

  {
    _id: "hp2",
    img: hp2,
    productName: "CORSAIR XENEON 32QHD240 32-Inch IPS QHD 240Hz",
    price: "699.00",
    color: "Blanc",
    badge: true,
    brand: "CORSAIR",
    des: "CORSAIR XENEON 32QHD240 32-Inch IPS QHD 240Hz The CORSAIR XENEON 32QHD240 brings your games and media to life on a vibrant, ultra-slim 32-inch QHD (2560 x1440) display with IPS LED technology. A 240Hz refresh rate and 1ms response time reduce motion blur and ensure you see every frame your PC outputs, while AMD FreeSync™ Premium delivers smooth, tear-free visuals, with NVIDIA® G-SYNC compatibility as well. Enjoy a 100% sRGB and 100% Adobe RGB color space with high contrast thanks to Quantum Dot technology and HDR600...",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [],
  },

  {
    _id: "hp3",
    img: hp3,
    productName: "8x External DVD Writer",
    price: "40.00",
    color: "Black",
    badge: true,
    brand: "ORIGIN",
    des: "8x External DVD Writer The LG GP50NB40 External DVD-Writer uses a USB 2.0 port to easily attach to your computer so that you can be ready to burn disks in no time. Use it at home, work or while traveling, to quickly, efficiently and effectively burn discs. The LG External DVD-Writer has a slim and lightweight design that makes it easy to carry, hold, pack and store. It has the USB cable included so it is ready to go, straight out of the box. This USB 2.0 DVD-writer is compatible with various...",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "DISPONIBILITÉ", value: "En stock" },
      { label: "gtin", value: "Z4B04A" },
      { label: "Marque", value: "HP" },
      { label: "Destockage", value: "Non" },
      { label: "Technologie d impression", value: "Multifonction Jet d'encre" },
      { label: "fonctions", value: "Multifonction" },
      { label: "Impression", value: "Couleur" },
      { label: "Mémoire", value: "Non" },
      { label: "FAX", value: "Non" },
      { label: "Fonctionnalités", value: "Impression, Copie, Numérisation" },
      { label: "Chargement de Documents", value: "Oui" },
      { label: "Connecteurs", value: "1 port USB 2.0 haut débit" },
      { label: "Vitesse du Processeur", value: "360 MHz" },
      {
        label: "Impression sans bordure",
        value: "Oui, jusqu’à 210 x 297 mm (A4)",
      },
      { label: "Vitesse d impression Noir", value: "Jusqu'à 19 ppm" },
      { label: "Vitesse d impression Couleur", value: "Jusqu'à 15 ppm" },
      {
        label: "Résolution d'impression Noir",
        value: "Jusqu'à 1 200 x 1 200 DPI",
      },
      {
        label: "Résolution d impression Couleur",
        value: "Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      {
        label: "Résolution d impression",
        value:
          "Jusqu'à 1 200 x 1 200 DPI (noir), Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      { label: "Type de Scanner", value: "Scanner à Plat" },
      { label: "Vitesse de numérisation", value: "Jusqu'à 21 secondes" },
      { label: "Résolution de Numérisation", value: "Jusqu'à 1200 x 1200 ppp" },
      {
        label: "Résolution de numérisation optimisée",
        value: "Jusqu’à 1200 ppp",
      },
      { label: "Recto/Verso", value: "Manuel" },
      { label: "Connectivite", value: "USB" },
      { label: "formats", value: "A4" },
      {
        label: "Premiére Page Imprimée",
        value:
          "Noir: (A4, prêt) Vitesse : 14 s - Couleur (A4, prêt) Vitesse : 18 s",
      },
      {
        label: "Alimentation-courant",
        value:
          "Tension d'entrée : 220 à 240 V CA (+/- 10 %), 50/60 Hz (+/- 3 Hz)",
      },
      {
        label: "Type de Papier pris en charge",
        value:
          "Papier ordinaire, papiers photo HP, papier mat pour brochure HP ou papier professionnel HP, papier mat pour présentation HP, papier brillant pour brochure HP ou papier professionnel HP, papiers photo jet d'encre, papiers mats jet d'encre, papiers brillant",
      },
      {
        label: "Consommation électrique",
        value:
          "10 W maximum, 0,07 W (Arrêt), 2,1 W (Veille), 0,88 W (Veille prolongée)",
      },
      {
        label: "Cycle d utilisation Mensuel",
        value: "A4: Jusqu'à 1 000 pages - Lettre: Jusqu'à 1 000 pages",
      },
      {
        label: "Alimentation papier standard",
        value:
          "Bac d'alimentation de 60 feuilles - Bac de sortie de 25 feuilles",
      },
      { label: "Ecran Tactile", value: "Non" },
      { label: "Type ecran", value: "7 segments et icône LCD" },
      {
        label: "Volume de Pages Mensuel Recommandé",
        value: "400 à 800 (Jusqu'à 1000 pages)",
      },
      { label: "Interfaces standard", value: "1x port USB 2.0 haut débit" },
      { label: "Résolution optique", value: "Jusqu'à 1200 x 1200 ppp" },
      { label: "Grammage", value: "75 g/m²" },
      {
        label: "Contenu de L'emballage",
        value:
          "HP Ink Tank 315 , cartouche d'encre noire HP GT51 (90CC), cartouche d'encre cyan HP GT52 (70CC), cartouche d'encre magenta HP GT52 (70CC), cartouche d'encre jaune HP GT52 (70CC)",
      },
      { label: "Poids", value: "4,67 kg" },
      { label: "Couleur", value: "Noir" },
      { label: "Dimensions", value: "525 x 310 x 158 mm" },
      { label: "Garantie", value: "1 an" },
    ],
  },
  // =================== imprimante ricoh =================
  {
    _id: "ricoh1",
    img: ricoh1,
    productName: "6x External Blu-Ray Writer",
    price: "99.00",
    color: "Black",
    badge: true,
    brand: "ORIGIN",
    des: "6x External Blu-Ray Writer The LG Slim Portable Blu-ray Writer model number is LG WP50NB40. The color of this portable rewriter is black and packaged in a retail box. The retail box includes a USB 2.0 cord, installation disc and quick installation guide documentation. The LG drive supports BDXL format. A BDXL 100GB disc is equivalent to 21 DVDs or 4 Blu-rays on just 1 BDXL disc.",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "DISPONIBILITÉ", value: "En stock" },
      { label: "gtin", value: "Z4B04A" },
      { label: "Marque", value: "HP" },
      { label: "Destockage", value: "Non" },
      { label: "Technologie d impression", value: "Multifonction Jet d'encre" },
      { label: "fonctions", value: "Multifonction" },
      { label: "Impression", value: "Couleur" },
      { label: "Mémoire", value: "Non" },
      { label: "FAX", value: "Non" },
      { label: "Fonctionnalités", value: "Impression, Copie, Numérisation" },
      { label: "Chargement de Documents", value: "Oui" },
      { label: "Connecteurs", value: "1 port USB 2.0 haut débit" },
      { label: "Vitesse du Processeur", value: "360 MHz" },
      {
        label: "Impression sans bordure",
        value: "Oui, jusqu’à 210 x 297 mm (A4)",
      },
      { label: "Vitesse d impression Noir", value: "Jusqu'à 19 ppm" },
      { label: "Vitesse d impression Couleur", value: "Jusqu'à 15 ppm" },
      {
        label: "Résolution d'impression Noir",
        value: "Jusqu'à 1 200 x 1 200 DPI",
      },
      {
        label: "Résolution d impression Couleur",
        value: "Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      {
        label: "Résolution d impression",
        value:
          "Jusqu'à 1 200 x 1 200 DPI (noir), Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      { label: "Type de Scanner", value: "Scanner à Plat" },
      { label: "Vitesse de numérisation", value: "Jusqu'à 21 secondes" },
      { label: "Résolution de Numérisation", value: "Jusqu'à 1200 x 1200 ppp" },
      {
        label: "Résolution de numérisation optimisée",
        value: "Jusqu’à 1200 ppp",
      },
      { label: "Recto/Verso", value: "Manuel" },
      { label: "Connectivite", value: "USB" },
      { label: "formats", value: "A4" },
      {
        label: "Premiére Page Imprimée",
        value:
          "Noir: (A4, prêt) Vitesse : 14 s - Couleur (A4, prêt) Vitesse : 18 s",
      },
      {
        label: "Alimentation-courant",
        value:
          "Tension d'entrée : 220 à 240 V CA (+/- 10 %), 50/60 Hz (+/- 3 Hz)",
      },
      {
        label: "Type de Papier pris en charge",
        value:
          "Papier ordinaire, papiers photo HP, papier mat pour brochure HP ou papier professionnel HP, papier mat pour présentation HP, papier brillant pour brochure HP ou papier professionnel HP, papiers photo jet d'encre, papiers mats jet d'encre, papiers brillant",
      },
      {
        label: "Consommation électrique",
        value:
          "10 W maximum, 0,07 W (Arrêt), 2,1 W (Veille), 0,88 W (Veille prolongée)",
      },
      {
        label: "Cycle d utilisation Mensuel",
        value: "A4: Jusqu'à 1 000 pages - Lettre: Jusqu'à 1 000 pages",
      },
      {
        label: "Alimentation papier standard",
        value:
          "Bac d'alimentation de 60 feuilles - Bac de sortie de 25 feuilles",
      },
      { label: "Ecran Tactile", value: "Non" },
      { label: "Type ecran", value: "7 segments et icône LCD" },
      {
        label: "Volume de Pages Mensuel Recommandé",
        value: "400 à 800 (Jusqu'à 1000 pages)",
      },
      { label: "Interfaces standard", value: "1x port USB 2.0 haut débit" },
      { label: "Résolution optique", value: "Jusqu'à 1200 x 1200 ppp" },
      { label: "Grammage", value: "75 g/m²" },
      {
        label: "Contenu de L'emballage",
        value:
          "HP Ink Tank 315 , cartouche d'encre noire HP GT51 (90CC), cartouche d'encre cyan HP GT52 (70CC), cartouche d'encre magenta HP GT52 (70CC), cartouche d'encre jaune HP GT52 (70CC)",
      },
      { label: "Poids", value: "4,67 kg" },
      { label: "Couleur", value: "Noir" },
      { label: "Dimensions", value: "525 x 310 x 158 mm" },
      { label: "Garantie", value: "1 an" },
    ],
  },

  {
    _id: "ricoh2",
    img: ricoh2,
    productName: "SCUF Instinct Pro Light Grey",
    price: "209.99",
    color: "White",
    badge: true,
    brand: "CORSAIR",
    des: "SCUF Instinct Pro Light Grey Every aspect of Instinct was designed to live up to its name. Four embedded, rear remappable paddles, three configuration profiles, switchable instant triggers, interchangeable thumbsticks and non-slip performance grip make this our most innovative Xbox controller yet. Play better. Play faster. CONNECTIVITY: WIRELESS (BLUETOOTH) Wired (USB-C Cable) Dimensions: L (168mm) x W (108mm) x H (53mm) Ports: USB-C, Extension Port, 3.5mm Stereo Headset Jack Thumbstick Layout:...",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "DISPONIBILITÉ", value: "En stock" },
      { label: "gtin", value: "Z4B04A" },
      { label: "Marque", value: "HP" },
      { label: "Destockage", value: "Non" },
      { label: "Technologie d impression", value: "Multifonction Jet d'encre" },
      { label: "fonctions", value: "Multifonction" },
      { label: "Impression", value: "Couleur" },
      { label: "Mémoire", value: "Non" },
      { label: "FAX", value: "Non" },
      { label: "Fonctionnalités", value: "Impression, Copie, Numérisation" },
      { label: "Chargement de Documents", value: "Oui" },
      { label: "Connecteurs", value: "1 port USB 2.0 haut débit" },
      { label: "Vitesse du Processeur", value: "360 MHz" },
      {
        label: "Impression sans bordure",
        value: "Oui, jusqu’à 210 x 297 mm (A4)",
      },
      { label: "Vitesse d impression Noir", value: "Jusqu'à 19 ppm" },
      { label: "Vitesse d impression Couleur", value: "Jusqu'à 15 ppm" },
      {
        label: "Résolution d'impression Noir",
        value: "Jusqu'à 1 200 x 1 200 DPI",
      },
      {
        label: "Résolution d impression Couleur",
        value: "Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      {
        label: "Résolution d impression",
        value:
          "Jusqu'à 1 200 x 1 200 DPI (noir), Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      { label: "Type de Scanner", value: "Scanner à Plat" },
      { label: "Vitesse de numérisation", value: "Jusqu'à 21 secondes" },
      { label: "Résolution de Numérisation", value: "Jusqu'à 1200 x 1200 ppp" },
      {
        label: "Résolution de numérisation optimisée",
        value: "Jusqu’à 1200 ppp",
      },
      { label: "Recto/Verso", value: "Manuel" },
      { label: "Connectivite", value: "USB" },
      { label: "formats", value: "A4" },
      {
        label: "Premiére Page Imprimée",
        value:
          "Noir: (A4, prêt) Vitesse : 14 s - Couleur (A4, prêt) Vitesse : 18 s",
      },
      {
        label: "Alimentation-courant",
        value:
          "Tension d'entrée : 220 à 240 V CA (+/- 10 %), 50/60 Hz (+/- 3 Hz)",
      },
      {
        label: "Type de Papier pris en charge",
        value:
          "Papier ordinaire, papiers photo HP, papier mat pour brochure HP ou papier professionnel HP, papier mat pour présentation HP, papier brillant pour brochure HP ou papier professionnel HP, papiers photo jet d'encre, papiers mats jet d'encre, papiers brillant",
      },
      {
        label: "Consommation électrique",
        value:
          "10 W maximum, 0,07 W (Arrêt), 2,1 W (Veille), 0,88 W (Veille prolongée)",
      },
      {
        label: "Cycle d utilisation Mensuel",
        value: "A4: Jusqu'à 1 000 pages - Lettre: Jusqu'à 1 000 pages",
      },
      {
        label: "Alimentation papier standard",
        value:
          "Bac d'alimentation de 60 feuilles - Bac de sortie de 25 feuilles",
      },
      { label: "Ecran Tactile", value: "Non" },
      { label: "Type ecran", value: "7 segments et icône LCD" },
      {
        label: "Volume de Pages Mensuel Recommandé",
        value: "400 à 800 (Jusqu'à 1000 pages)",
      },
      { label: "Interfaces standard", value: "1x port USB 2.0 haut débit" },
      { label: "Résolution optique", value: "Jusqu'à 1200 x 1200 ppp" },
      { label: "Grammage", value: "75 g/m²" },
      {
        label: "Contenu de L'emballage",
        value:
          "HP Ink Tank 315 , cartouche d'encre noire HP GT51 (90CC), cartouche d'encre cyan HP GT52 (70CC), cartouche d'encre magenta HP GT52 (70CC), cartouche d'encre jaune HP GT52 (70CC)",
      },
      { label: "Poids", value: "4,67 kg" },
      { label: "Couleur", value: "Noir" },
      { label: "Dimensions", value: "525 x 310 x 158 mm" },
      { label: "Garantie", value: "1 an" },
    ],
  },
  {
    _id: "ricoh3",
    img: ricoh3,
    productName: "SCUF Instinct Pro BIG O Edition",
    price: "209.99",
    color: "Black",
    badge: true,
    brand: "CORSAIR",
    des: "SCUF Instinct Pro BIG O Edition Every aspect of Instinct was designed to live up to its name. Four embedded, rear remappable paddles, three configuration profiles, switchable instant triggers, interchangeable thumbsticks and non-slip performance grip make this our most innovative Xbox controller yet. Play better. Play faster. CONNECTIVITY: WIRELESS (BLUETOOTH) Wired (USB-C Cable) Dimensions: L (168mm) x W (108mm) x H (53mm) Ports: USB-C, Extension Port, 3.5mm Stereo Headset Jack Thumbstick Layout:...",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "DISPONIBILITÉ", value: "En stock" },
      { label: "gtin", value: "Z4B04A" },
      { label: "Marque", value: "HP" },
      { label: "Destockage", value: "Non" },
      { label: "Technologie d impression", value: "Multifonction Jet d'encre" },
      { label: "fonctions", value: "Multifonction" },
      { label: "Impression", value: "Couleur" },
      { label: "Mémoire", value: "Non" },
      { label: "FAX", value: "Non" },
      { label: "Fonctionnalités", value: "Impression, Copie, Numérisation" },
      { label: "Chargement de Documents", value: "Oui" },
      { label: "Connecteurs", value: "1 port USB 2.0 haut débit" },
      { label: "Vitesse du Processeur", value: "360 MHz" },
      {
        label: "Impression sans bordure",
        value: "Oui, jusqu’à 210 x 297 mm (A4)",
      },
      { label: "Vitesse d impression Noir", value: "Jusqu'à 19 ppm" },
      { label: "Vitesse d impression Couleur", value: "Jusqu'à 15 ppm" },
      {
        label: "Résolution d'impression Noir",
        value: "Jusqu'à 1 200 x 1 200 DPI",
      },
      {
        label: "Résolution d impression Couleur",
        value: "Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      {
        label: "Résolution d impression",
        value:
          "Jusqu'à 1 200 x 1 200 DPI (noir), Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      { label: "Type de Scanner", value: "Scanner à Plat" },
      { label: "Vitesse de numérisation", value: "Jusqu'à 21 secondes" },
      { label: "Résolution de Numérisation", value: "Jusqu'à 1200 x 1200 ppp" },
      {
        label: "Résolution de numérisation optimisée",
        value: "Jusqu’à 1200 ppp",
      },
      { label: "Recto/Verso", value: "Manuel" },
      { label: "Connectivite", value: "USB" },
      { label: "formats", value: "A4" },
      {
        label: "Premiére Page Imprimée",
        value:
          "Noir: (A4, prêt) Vitesse : 14 s - Couleur (A4, prêt) Vitesse : 18 s",
      },
      {
        label: "Alimentation-courant",
        value:
          "Tension d'entrée : 220 à 240 V CA (+/- 10 %), 50/60 Hz (+/- 3 Hz)",
      },
      {
        label: "Type de Papier pris en charge",
        value:
          "Papier ordinaire, papiers photo HP, papier mat pour brochure HP ou papier professionnel HP, papier mat pour présentation HP, papier brillant pour brochure HP ou papier professionnel HP, papiers photo jet d'encre, papiers mats jet d'encre, papiers brillant",
      },
      {
        label: "Consommation électrique",
        value:
          "10 W maximum, 0,07 W (Arrêt), 2,1 W (Veille), 0,88 W (Veille prolongée)",
      },
      {
        label: "Cycle d utilisation Mensuel",
        value: "A4: Jusqu'à 1 000 pages - Lettre: Jusqu'à 1 000 pages",
      },
      {
        label: "Alimentation papier standard",
        value:
          "Bac d'alimentation de 60 feuilles - Bac de sortie de 25 feuilles",
      },
      { label: "Ecran Tactile", value: "Non" },
      { label: "Type ecran", value: "7 segments et icône LCD" },
      {
        label: "Volume de Pages Mensuel Recommandé",
        value: "400 à 800 (Jusqu'à 1000 pages)",
      },
      { label: "Interfaces standard", value: "1x port USB 2.0 haut débit" },
      { label: "Résolution optique", value: "Jusqu'à 1200 x 1200 ppp" },
      { label: "Grammage", value: "75 g/m²" },
      {
        label: "Contenu de L'emballage",
        value:
          "HP Ink Tank 315 , cartouche d'encre noire HP GT51 (90CC), cartouche d'encre cyan HP GT52 (70CC), cartouche d'encre magenta HP GT52 (70CC), cartouche d'encre jaune HP GT52 (70CC)",
      },
      { label: "Poids", value: "4,67 kg" },
      { label: "Couleur", value: "Noir" },
      { label: "Dimensions", value: "525 x 310 x 158 mm" },
      { label: "Garantie", value: "1 an" },
    ],
  },
  {
    _id: "ricoh4",
    img: ricoh4,
    productName: "K55 RGB PRO Gaming Keyboard",
    price: "59.99",
    color: "Black",
    badge: true,
    brand: "CORSAIR",
    des: "K55 RGB PRO Gaming Keyboard The CORSAIR K55 RGB PRO Gaming Keyboard lights up your desktop with five-zone dynamic RGB backlighting and powers up your gameplay with six dedicated macro keys.",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "DISPONIBILITÉ", value: "En stock" },
      { label: "gtin", value: "Z4B04A" },
      { label: "Marque", value: "HP" },
      { label: "Destockage", value: "Non" },
      { label: "Technologie d impression", value: "Multifonction Jet d'encre" },
      { label: "fonctions", value: "Multifonction" },
      { label: "Impression", value: "Couleur" },
      { label: "Mémoire", value: "Non" },
      { label: "FAX", value: "Non" },
      { label: "Fonctionnalités", value: "Impression, Copie, Numérisation" },
      { label: "Chargement de Documents", value: "Oui" },
      { label: "Connecteurs", value: "1 port USB 2.0 haut débit" },
      { label: "Vitesse du Processeur", value: "360 MHz" },
      {
        label: "Impression sans bordure",
        value: "Oui, jusqu’à 210 x 297 mm (A4)",
      },
      { label: "Vitesse d impression Noir", value: "Jusqu'à 19 ppm" },
      { label: "Vitesse d impression Couleur", value: "Jusqu'à 15 ppm" },
      {
        label: "Résolution d'impression Noir",
        value: "Jusqu'à 1 200 x 1 200 DPI",
      },
      {
        label: "Résolution d impression Couleur",
        value: "Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      {
        label: "Résolution d impression",
        value:
          "Jusqu'à 1 200 x 1 200 DPI (noir), Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      { label: "Type de Scanner", value: "Scanner à Plat" },
      { label: "Vitesse de numérisation", value: "Jusqu'à 21 secondes" },
      { label: "Résolution de Numérisation", value: "Jusqu'à 1200 x 1200 ppp" },
      {
        label: "Résolution de numérisation optimisée",
        value: "Jusqu’à 1200 ppp",
      },
      { label: "Recto/Verso", value: "Manuel" },
      { label: "Connectivite", value: "USB" },
      { label: "formats", value: "A4" },
      {
        label: "Premiére Page Imprimée",
        value:
          "Noir: (A4, prêt) Vitesse : 14 s - Couleur (A4, prêt) Vitesse : 18 s",
      },
      {
        label: "Alimentation-courant",
        value:
          "Tension d'entrée : 220 à 240 V CA (+/- 10 %), 50/60 Hz (+/- 3 Hz)",
      },
      {
        label: "Type de Papier pris en charge",
        value:
          "Papier ordinaire, papiers photo HP, papier mat pour brochure HP ou papier professionnel HP, papier mat pour présentation HP, papier brillant pour brochure HP ou papier professionnel HP, papiers photo jet d'encre, papiers mats jet d'encre, papiers brillant",
      },
      {
        label: "Consommation électrique",
        value:
          "10 W maximum, 0,07 W (Arrêt), 2,1 W (Veille), 0,88 W (Veille prolongée)",
      },
      {
        label: "Cycle d utilisation Mensuel",
        value: "A4: Jusqu'à 1 000 pages - Lettre: Jusqu'à 1 000 pages",
      },
      {
        label: "Alimentation papier standard",
        value:
          "Bac d'alimentation de 60 feuilles - Bac de sortie de 25 feuilles",
      },
      { label: "Ecran Tactile", value: "Non" },
      { label: "Type ecran", value: "7 segments et icône LCD" },
      {
        label: "Volume de Pages Mensuel Recommandé",
        value: "400 à 800 (Jusqu'à 1000 pages)",
      },
      { label: "Interfaces standard", value: "1x port USB 2.0 haut débit" },
      { label: "Résolution optique", value: "Jusqu'à 1200 x 1200 ppp" },
      { label: "Grammage", value: "75 g/m²" },
      {
        label: "Contenu de L'emballage",
        value:
          "HP Ink Tank 315 , cartouche d'encre noire HP GT51 (90CC), cartouche d'encre cyan HP GT52 (70CC), cartouche d'encre magenta HP GT52 (70CC), cartouche d'encre jaune HP GT52 (70CC)",
      },
      { label: "Poids", value: "4,67 kg" },
      { label: "Couleur", value: "Noir" },
      { label: "Dimensions", value: "525 x 310 x 158 mm" },
      { label: "Garantie", value: "1 an" },
    ],
  },
  {
    _id: "ricoh5",
    img: ricoh5,
    productName: "K65 RGB MINI 60% Mechanical Gaming Keyboard — CHERRY MX SPEED — White",
    price: "109.99",
    color: "Black",
    badge: true,
    brand: "ORIGIN",
    des: "K65 RGB MINI 60% Mechanical Gaming Keyboard — CHERRY MX SPEED — White The CORSAIR K65 RGB RAPIDFIRE Compact Mechanical Keyboard offers the reliability and precision of CHERRY MX mechanical keyswitches in a tenkeyless form factor that fits effortlessly into any desktop setup.",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "DISPONIBILITÉ", value: "En stock" },
      { label: "gtin", value: "Z4B04A" },
      { label: "Marque", value: "HP" },
      { label: "Destockage", value: "Non" },
      { label: "Technologie d impression", value: "Multifonction Jet d'encre" },
      { label: "fonctions", value: "Multifonction" },
      { label: "Impression", value: "Couleur" },
      { label: "Mémoire", value: "Non" },
      { label: "FAX", value: "Non" },
      { label: "Fonctionnalités", value: "Impression, Copie, Numérisation" },
      { label: "Chargement de Documents", value: "Oui" },
      { label: "Connecteurs", value: "1 port USB 2.0 haut débit" },
      { label: "Vitesse du Processeur", value: "360 MHz" },
      {
        label: "Impression sans bordure",
        value: "Oui, jusqu’à 210 x 297 mm (A4)",
      },
      { label: "Vitesse d impression Noir", value: "Jusqu'à 19 ppm" },
      { label: "Vitesse d impression Couleur", value: "Jusqu'à 15 ppm" },
      {
        label: "Résolution d'impression Noir",
        value: "Jusqu'à 1 200 x 1 200 DPI",
      },
      {
        label: "Résolution d impression Couleur",
        value: "Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      {
        label: "Résolution d impression",
        value:
          "Jusqu'à 1 200 x 1 200 DPI (noir), Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      { label: "Type de Scanner", value: "Scanner à Plat" },
      { label: "Vitesse de numérisation", value: "Jusqu'à 21 secondes" },
      { label: "Résolution de Numérisation", value: "Jusqu'à 1200 x 1200 ppp" },
      {
        label: "Résolution de numérisation optimisée",
        value: "Jusqu’à 1200 ppp",
      },
      { label: "Recto/Verso", value: "Manuel" },
      { label: "Connectivite", value: "USB" },
      { label: "formats", value: "A4" },
      {
        label: "Premiére Page Imprimée",
        value:
          "Noir: (A4, prêt) Vitesse : 14 s - Couleur (A4, prêt) Vitesse : 18 s",
      },
      {
        label: "Alimentation-courant",
        value:
          "Tension d'entrée : 220 à 240 V CA (+/- 10 %), 50/60 Hz (+/- 3 Hz)",
      },
      {
        label: "Type de Papier pris en charge",
        value:
          "Papier ordinaire, papiers photo HP, papier mat pour brochure HP ou papier professionnel HP, papier mat pour présentation HP, papier brillant pour brochure HP ou papier professionnel HP, papiers photo jet d'encre, papiers mats jet d'encre, papiers brillant",
      },
      {
        label: "Consommation électrique",
        value:
          "10 W maximum, 0,07 W (Arrêt), 2,1 W (Veille), 0,88 W (Veille prolongée)",
      },
      {
        label: "Cycle d utilisation Mensuel",
        value: "A4: Jusqu'à 1 000 pages - Lettre: Jusqu'à 1 000 pages",
      },
      {
        label: "Alimentation papier standard",
        value:
          "Bac d'alimentation de 60 feuilles - Bac de sortie de 25 feuilles",
      },
      { label: "Ecran Tactile", value: "Non" },
      { label: "Type ecran", value: "7 segments et icône LCD" },
      {
        label: "Volume de Pages Mensuel Recommandé",
        value: "400 à 800 (Jusqu'à 1000 pages)",
      },
      { label: "Interfaces standard", value: "1x port USB 2.0 haut débit" },
      { label: "Résolution optique", value: "Jusqu'à 1200 x 1200 ppp" },
      { label: "Grammage", value: "75 g/m²" },
      {
        label: "Contenu de L'emballage",
        value:
          "HP Ink Tank 315 , cartouche d'encre noire HP GT51 (90CC), cartouche d'encre cyan HP GT52 (70CC), cartouche d'encre magenta HP GT52 (70CC), cartouche d'encre jaune HP GT52 (70CC)",
      },
      { label: "Poids", value: "4,67 kg" },
      { label: "Couleur", value: "Noir" },
      { label: "Dimensions", value: "525 x 310 x 158 mm" },
      { label: "Garantie", value: "1 an" },
    ],
  },

  // =================== imprimante ricoh =================

  {
    _id: "espson1",
    img: espson1,
    productName: "Elgato Wave Pop Filter",
    price: "159.99",
    color: "White",
    badge: true,
    brand: "GIGABYTE",
    des: "Elgato Wave Pop Filter MAXIMUM AUDIO TRANSPARENCY Wave Pop Filter features dual-layer steel mesh for optimum air current diffusion, eliminating pops and hisses caused by plosive speech sounds . EASY SETUP Simply align the magnetic attachment points, let Wave Pop Filter snap into place, and say your p’s and b’s without distortion. CUSTOM BUILT A precise fit with looks to match, Wave Pop Filter is the perfect addition to your premium Wave:1 or Wave:3 microphone.",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "DISPONIBILITÉ", value: "En stock" },
      { label: "gtin", value: "Z4B04A" },
      { label: "Marque", value: "HP" },
      { label: "Destockage", value: "Non" },
      { label: "Technologie d impression", value: "Multifonction Jet d'encre" },
      { label: "fonctions", value: "Multifonction" },
      { label: "Impression", value: "Couleur" },
      { label: "Mémoire", value: "Non" },
      { label: "FAX", value: "Non" },
      { label: "Fonctionnalités", value: "Impression, Copie, Numérisation" },
      { label: "Chargement de Documents", value: "Oui" },
      { label: "Connecteurs", value: "1 port USB 2.0 haut débit" },
      { label: "Vitesse du Processeur", value: "360 MHz" },
      {
        label: "Impression sans bordure",
        value: "Oui, jusqu’à 210 x 297 mm (A4)",
      },
      { label: "Vitesse d impression Noir", value: "Jusqu'à 19 ppm" },
      { label: "Vitesse d impression Couleur", value: "Jusqu'à 15 ppm" },
      {
        label: "Résolution d'impression Noir",
        value: "Jusqu'à 1 200 x 1 200 DPI",
      },
      {
        label: "Résolution d impression Couleur",
        value: "Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      {
        label: "Résolution d impression",
        value:
          "Jusqu'à 1 200 x 1 200 DPI (noir), Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      { label: "Type de Scanner", value: "Scanner à Plat" },
      { label: "Vitesse de numérisation", value: "Jusqu'à 21 secondes" },
      { label: "Résolution de Numérisation", value: "Jusqu'à 1200 x 1200 ppp" },
      {
        label: "Résolution de numérisation optimisée",
        value: "Jusqu’à 1200 ppp",
      },
      { label: "Recto/Verso", value: "Manuel" },
      { label: "Connectivite", value: "USB" },
      { label: "formats", value: "A4" },
      {
        label: "Premiére Page Imprimée",
        value:
          "Noir: (A4, prêt) Vitesse : 14 s - Couleur (A4, prêt) Vitesse : 18 s",
      },
      {
        label: "Alimentation-courant",
        value:
          "Tension d'entrée : 220 à 240 V CA (+/- 10 %), 50/60 Hz (+/- 3 Hz)",
      },
      {
        label: "Type de Papier pris en charge",
        value:
          "Papier ordinaire, papiers photo HP, papier mat pour brochure HP ou papier professionnel HP, papier mat pour présentation HP, papier brillant pour brochure HP ou papier professionnel HP, papiers photo jet d'encre, papiers mats jet d'encre, papiers brillant",
      },
      {
        label: "Consommation électrique",
        value:
          "10 W maximum, 0,07 W (Arrêt), 2,1 W (Veille), 0,88 W (Veille prolongée)",
      },
      {
        label: "Cycle d utilisation Mensuel",
        value: "A4: Jusqu'à 1 000 pages - Lettre: Jusqu'à 1 000 pages",
      },
      {
        label: "Alimentation papier standard",
        value:
          "Bac d'alimentation de 60 feuilles - Bac de sortie de 25 feuilles",
      },
      { label: "Ecran Tactile", value: "Non" },
      { label: "Type ecran", value: "7 segments et icône LCD" },
      {
        label: "Volume de Pages Mensuel Recommandé",
        value: "400 à 800 (Jusqu'à 1000 pages)",
      },
      { label: "Interfaces standard", value: "1x port USB 2.0 haut débit" },
      { label: "Résolution optique", value: "Jusqu'à 1200 x 1200 ppp" },
      { label: "Grammage", value: "75 g/m²" },
      {
        label: "Contenu de L'emballage",
        value:
          "HP Ink Tank 315 , cartouche d'encre noire HP GT51 (90CC), cartouche d'encre cyan HP GT52 (70CC), cartouche d'encre magenta HP GT52 (70CC), cartouche d'encre jaune HP GT52 (70CC)",
      },
      { label: "Poids", value: "4,67 kg" },
      { label: "Couleur", value: "Noir" },
      { label: "Dimensions", value: "525 x 310 x 158 mm" },
      { label: "Garantie", value: "1 an" },
    ],
  },

  {
    _id: "espson2",
    img: espson2,
    productName: "Elgato Wave 3",
    price: "29.99",
    color: "White",
    badge: true,
    brand: "GIGABYTE",
    des: "Elgato Wave 3 TAILORED FOR CREATORS Quality content requires excellent sound. You need a broadcast-grade microphone that plugs directly into your setup, and a mixer to blend audio sources with ease. Meet Wave:3 — your complete solution. CAPSULE 17 mm Electret POLAR PATTERN Cardioid RESOLUTION 24-bit SAMPLE RATE 48 / 96 kHz FREQUENCY RESPONSE 70 - 20000 Hz SENSITIVITY -25dBFS (min gain) | 15dBFS (max gain) MAX SPL 120dB (140dB Clipguard engaged) DYNAMIC RANGE 95dB (115dB Clipguard engaged)...",
    cat: "Imprimante",
    pdf: pdf1,
    ficheTech: [
      { label: "DISPONIBILITÉ", value: "En stock" },
      { label: "gtin", value: "Z4B04A" },
      { label: "Marque", value: "HP" },
      { label: "Destockage", value: "Non" },
      { label: "Technologie d impression", value: "Multifonction Jet d'encre" },
      { label: "fonctions", value: "Multifonction" },
      { label: "Impression", value: "Couleur" },
      { label: "Mémoire", value: "Non" },
      { label: "FAX", value: "Non" },
      { label: "Fonctionnalités", value: "Impression, Copie, Numérisation" },
      { label: "Chargement de Documents", value: "Oui" },
      { label: "Connecteurs", value: "1 port USB 2.0 haut débit" },
      { label: "Vitesse du Processeur", value: "360 MHz" },
      {
        label: "Impression sans bordure",
        value: "Oui, jusqu’à 210 x 297 mm (A4)",
      },
      { label: "Vitesse d impression Noir", value: "Jusqu'à 19 ppm" },
      { label: "Vitesse d impression Couleur", value: "Jusqu'à 15 ppm" },
      {
        label: "Résolution d'impression Noir",
        value: "Jusqu'à 1 200 x 1 200 DPI",
      },
      {
        label: "Résolution d impression Couleur",
        value: "Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      {
        label: "Résolution d impression",
        value:
          "Jusqu'à 1 200 x 1 200 DPI (noir), Jusqu'à 4 800 x 1 200 DPI (couleur)",
      },
      { label: "Type de Scanner", value: "Scanner à Plat" },
      { label: "Vitesse de numérisation", value: "Jusqu'à 21 secondes" },
      { label: "Résolution de Numérisation", value: "Jusqu'à 1200 x 1200 ppp" },
      {
        label: "Résolution de numérisation optimisée",
        value: "Jusqu’à 1200 ppp",
      },
      { label: "Recto/Verso", value: "Manuel" },
      { label: "Connectivite", value: "USB" },
      { label: "formats", value: "A4" },
      {
        label: "Premiére Page Imprimée",
        value:
          "Noir: (A4, prêt) Vitesse : 14 s - Couleur (A4, prêt) Vitesse : 18 s",
      },
      {
        label: "Alimentation-courant",
        value:
          "Tension d'entrée : 220 à 240 V CA (+/- 10 %), 50/60 Hz (+/- 3 Hz)",
      },
      {
        label: "Type de Papier pris en charge",
        value:
          "Papier ordinaire, papiers photo HP, papier mat pour brochure HP ou papier professionnel HP, papier mat pour présentation HP, papier brillant pour brochure HP ou papier professionnel HP, papiers photo jet d'encre, papiers mats jet d'encre, papiers brillant",
      },
      {
        label: "Consommation électrique",
        value:
          "10 W maximum, 0,07 W (Arrêt), 2,1 W (Veille), 0,88 W (Veille prolongée)",
      },
      {
        label: "Cycle d utilisation Mensuel",
        value: "A4: Jusqu'à 1 000 pages - Lettre: Jusqu'à 1 000 pages",
      },
      {
        label: "Alimentation papier standard",
        value:
          "Bac d'alimentation de 60 feuilles - Bac de sortie de 25 feuilles",
      },
      { label: "Ecran Tactile", value: "Non" },
      { label: "Type ecran", value: "7 segments et icône LCD" },
      {
        label: "Volume de Pages Mensuel Recommandé",
        value: "400 à 800 (Jusqu'à 1000 pages)",
      },
      { label: "Interfaces standard", value: "1x port USB 2.0 haut débit" },
      { label: "Résolution optique", value: "Jusqu'à 1200 x 1200 ppp" },
      { label: "Grammage", value: "75 g/m²" },
      {
        label: "Contenu de L'emballage",
        value:
          "HP Ink Tank 315 , cartouche d'encre noire HP GT51 (90CC), cartouche d'encre cyan HP GT52 (70CC), cartouche d'encre magenta HP GT52 (70CC), cartouche d'encre jaune HP GT52 (70CC)",
      },
      { label: "Poids", value: "4,67 kg" },
      { label: "Couleur", value: "Noir" },
      { label: "Dimensions", value: "525 x 310 x 158 mm" },
      { label: "Garantie", value: "1 an" },
    ],
  },
];
